<div
  class="showtime-streaming-no-options tab-msg"
  [attr.data-translate]="noOptionsMessage"
  *ngIf="movie !== null && pageTypesOptions.length === 0"
>
  {{ noOptionsMessage }}
</div>
<div
  id="showtime-streaming"
  class="showtime-streaming"
  *ngIf="movie !== null && pageTypesOptions.length > 0 && activeType"
>
  <p-selectButton
    *ngIf="pageTypesOptions.length > 1 || showStreamingTitleAlways"
    [options]="pageTypesOptions"
    optionLabel="label"
    optionValue="value"
    [(ngModel)]="activeType"
    (ngModelChange)="onChangeType($event)"
    class="tabs"
  >
    <ng-template let-item pTemplate>
      <span [attr.data-translate]="'title.' + (item.value | cammelCase)">{{
        'title.' + (item.value | cammelCase) | translate
      }}</span>
    </ng-template>
  </p-selectButton>

  <div class="tab-container" [ngSwitch]="activeType">
    <ng-container *ngSwitchCase="'in-cinemas'">
      <ush-showtime-streaming-in-cinemas
        *ngIf="showInCinemas"
        [movie]="movie()"
        [enableRouterNavigation]="enableRouterNavigation"
        [showUsheruLogo]="showUsheruLogo"
        [inCinemasAddon]="inCinemasAddon"
        [openFirstPanel]="openFirstPanel"
        [inlineMap]="inlineMap"
        (showsLoaded)="onShowtimesLoaded()"
        (showtimeTicketing)="onShowtimeTicketingHandle($event)"
      >
      </ush-showtime-streaming-in-cinemas>
    </ng-container>

    <ng-container *ngSwitchCase="'watch-at-home'">
      <ush-showtime-streaming-watch-at-home
        *ngIf="showWatchAtHome"
        [movie]="movie()"
        [showUsheruLogo]="showUsheruLogo"
        (streamingPlatformsLoaded)="onStreamingPlatformsLoaded()"
      >
      </ush-showtime-streaming-watch-at-home>
    </ng-container>

    <ng-container *ngSwitchCase="'at-festivals'">
      <ush-showtime-streaming-at-festivals *ngIf="showAtFestivals" [movieFestivals]="movie().movieFestivals">
      </ush-showtime-streaming-at-festivals>
    </ng-container>

    <ng-container *ngSwitchCase="'enquiries'">
      <ush-enquiries [movie]="movie()"></ush-enquiries>
    </ng-container>
  </div>
</div>

<!-- Contact us Template -->
<ng-container *ngIf="!forceDisableSubscription">
  <ush-showtime-streaming-subscribe
    *ngIf="showDemandItForm"
    [movie]="movie()"
    [type]="subscribeType"
    [customTitleTr]="customSubscribeTitleTr"
    [customDescTr]="customSubscribeDescTr"
  >
  </ush-showtime-streaming-subscribe>
</ng-container>

<!-- Loading Template-->
<ng-template #loading>
  <ush-loading-indicator fontSize="30px" height="100px"></ush-loading-indicator>
</ng-template>
